import React from 'react';
import DvrOutlinedIcon from "@mui/icons-material/DvrOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import TranslateOutlinedIcon from "@mui/icons-material/TranslateOutlined";
import { Link } from '@randajan/jet-react/dom/link';

import "./EventCard.scss";
import { ImgStore } from '../../../elements/ImgStore/ImgStore';
import { Locale } from '../../../assets/Locale';
import { LocaleFlag } from '../../../frames/Locales/LocaleFlag/LocaleFlag';
import { buildEventDetail } from '../EventDetail/eventDetailData';
import { EventDate } from '../parts/EventDate/EventDate';
import { EventSignAction } from '../parts/EventSignAction/EventSignAction';
import { EventUserCount } from '../parts/EventUserCount/EventUserCount';

export const EventCard = ({ event })=>{
    const say = Locale.use();
    const detail = buildEventDetail(event, null, say);
    const place = event.gameSpace?.name || event.gameSpace?.address;

    return (
        <section className="EventCard wall -dark -border">
            <div className="visual">
                <ImgStore src={event.webImg ?? "eventImgDefault"}/>
            </div>
            <Link className="content" to={`/events/${event.id}`}>
                <header className="header">
                    <p className="eyebrow">{detail.labels.eventKind}</p>
                    <div className="status">
                        <strong className={detail.isOpen ? "positive" : ""}>{detail.statusLabel}</strong>
                        <span>{detail.accessLabel}</span>
                    </div>
                </header>
                <div className="body">
                    <div className="title">{detail.title}</div>
                    <ul className="infoPanel">
                        {event.startAtEst && <li><EventOutlinedIcon/><EventDate value={event.startAtEst} row={event}/></li>}
                        {place && <li><PlaceOutlinedIcon/><span>{place}</span></li>}
                        <li><DvrOutlinedIcon/><span>{detail.recordLabel}</span></li>
                        <li><GroupsOutlinedIcon/><EventUserCount value={event.gameEventUsers} row={event}/></li>
                        {detail.localeLabel && <li><TranslateOutlinedIcon/><span>{detail.localeLabel}</span><LocaleFlag locale={event.locale}/></li>}
                    </ul>
                </div>
            </Link>
            <footer className="footer">
                <EventSignAction eventId={event.id}/>
            </footer>
        </section>
    );
};

